let state = {
    blockUI: false,
	applicationName: "",
	authenticated: false,
	apikey: "",
	print: false,
	printTitle: ""
}

export default state;



// WEBPACK FOOTER //
// ./src/redux/util/initialState.js